import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ComponentManager from './pages/componentManager';
import ComponentEditor from './pages/ComponentEditor';
import ComponentViewer from './pages/ComponentViewer';
import Navbar from './components/organisms/Navbar';
import About from './pages/About';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import ProtectedRoute from './components/ProtectedRoute';
import Library from './pages/Library';
import Categories from './pages/Categories';
import { ToastProvider } from './components/atoms/Toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Profile from './pages/Profile';

function LoginWrapper({ Component }) {
  const { setToken } = useAuth();
  const onLogin = (token) => setToken(token);
  return <Component onLogin={onLogin} />;
}

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <ToastProvider>
          <Navbar />
          {/* Main application container */}
          <div className="min-h-screen bg-white">
            <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/components" element={<ComponentManager />} />
          <Route path="/components/edit/:id" element={<ProtectedRoute><ComponentEditor /></ProtectedRoute>} />
          <Route path="/components/view/:id" element={<ProtectedRoute><ComponentViewer /></ProtectedRoute>} />
          <Route path="/components/create" element={<ProtectedRoute><ComponentEditor /></ProtectedRoute>} />
          <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<LoginWrapper Component={LoginPage} />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/signin" element={<div>Sign In Page (Coming Soon)</div>} />
          <Route path="/dashboard" element={<div>Dashboard (Coming Soon)</div>} />
            </Routes>
          </div>
        </ToastProvider>
      </Router>
    </AuthProvider>
  );
};

export default App;